<template>
  <v-main class="tpadding">
    <v-container fluid>
      <v-card class="rounded-xl elevation-5">
        <v-toolbar dense dark color="pinkKonect" elevation="2">
          <v-toolbar-title>Reporte de usuarios</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn :disabled="items == 0" elevation="0" text small :loading="loading">
            <xlsx-workbook>
              <xlsx-sheet
                :collection="sheet.data"
                v-for="sheet in sheetsGeneral"
                :key="sheet.name"
                :sheet-name="sheet.name"
              />
              <xlsx-download :filename="'Reporte ' + this.reportTypeGeneral + '.xlsx'">
                <button>DESCARGAR</button>
                <v-icon right>mdi-microsoft-excel</v-icon>
              </xlsx-download>
            </xlsx-workbook>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row no-gutters>
            <v-col sm="4">
              <v-autocomplete
                v-model="state"
                append-icon="mdi-chevron-down"
                label="Estado"
                :items="stateValue"
                @change="refresh()"
                hide-details
                class="pa-5 mt-0"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-text-field
                class="pa-5 mt-0"
                v-model="search"
                label="Buscar"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-col>
            <v-col sm="4" style="align-self: center; text-align: right">
              <v-btn
                small
                v-if="isWritingVan"
                center
                outlined
                :disabled="!state"
                :loading="loading"
                color="blueKonect"
                class="ma-auto mr-4"
                elevation="0"
                @click="openMultipleMail()"
              >
                Reserva multiple
              </v-btn>
              <v-btn
                small
                center
                outlined
                :disabled="!state"
                :loading="loading"
                color="blueKonect"
                class="ma-auto"
                elevation="0"
                @click="refresh()"
              >
                Consultar
                <v-icon right>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :search="search"
            :items-per-page="5"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              itemsPerPageAllText: 'Todos'
            }"
          >
            <template v-slot:[`item.estado`]="{ item }">
              <infoChip
                :text="item.estado ? 'Activo' : 'Inactivo'"
                :color="item.estado ? 'success' : 'error'"
                :iconName="item.estado ? 'mdi-account' : 'mdi-account'"
                rightIcon
              />
            </template>
            <template v-slot:[`item.cliente_codigo_usuario_fecha_borrado`]="{ item }">
              <infoChip
                :text="!item.cliente_codigo_usuario_fecha_borrado ? 'Activo' : 'Eliminado'"
                :color="!item.cliente_codigo_usuario_fecha_borrado ? 'success' : 'error'"
                :iconName="!item.cliente_codigo_usuario_fecha_borrado ? 'mdi-check-outline' : 'mdi-cancel'"
                rightIcon
              />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <infoBtn
                :icon="item.cliente_codigo_usuario_fecha_borrado == null ? 'mdi-lock-reset' : ''"
                actionColor="primary"
                text="Actualizar contraseña"
                :data="item"
                :onClick="openChangePassword"
                :permission="!canChangePasswords"
              />
              <infoBtn
                :icon="item.cliente_codigo_usuario_fecha_borrado == null ? 'mdi-pencil' : ''"
                :actionColor="'primary'"
                :text="'Editar usuario'"
                :data="item"
                :onClick="view"
                :permission="!isWriting"
              />
              <infoBtn
                v-if="item.cliente_codigo_usuario_fecha_borrado == null"
                :icon="item.estado ? 'mdi-account-cancel' : 'mdi-account-check'"
                :text="
                  item.estado
                    ? 'Desactiva el acceso al usuario para que no pueda ver las rutas con su actual código o nuevos códigos'
                    : 'Activa el acceso al usuario para que no pueda ver las rutas con su actual código o nuevos códigos'
                "
                :actionColor="item.estado ? 'error' : 'success'"
                :data="item"
                :onClick="statusUser"
                :permission="!isWriting"
              />
              <infoBtn
                :icon="item.cliente_codigo_usuario_fecha_borrado == null ? 'mdi-cancel' : ''"
                :text="
                  item.cliente_codigo_usuario_fecha_borrado
                    ? 'Activa el código del usuario para que no pueda usar más el código actual.'
                    : 'Desactiva el código del usuario para que no pueda usar más el código actual.'
                "
                :actionColor="item.cliente_codigo_usuario_fecha_borrado ? 'success' : 'error'"
                :data="item"
                :onClick="remove"
                :permission="!isWriting"
              />
              <infoBtn
                :icon="item.bloqueo_por_id ? 'mdi-check' : 'mdi-close-box-multiple'"
                :actionColor="item.bloqueo_por_id ? 'success' : 'error'"
                v-if="isWritingVan"
                :text="item.bloqueo_por_id ? 'Habilitar reserva múltiple van.' : 'Deshabilitar reserva múltiple van.'"
                :data="item"
                :onClick="removeEmail"
                :permission="!isWriting"
              />
            </template>

            <template v-slot:[`footer.page-text`]="props">
              Página {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-data> No hay información disponible </template>
            <template v-slot:no-results> No se obtuvieron resultados </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-dialog v-model="dialogs.detail" persistent scrollable max-width="600px">
        <v-card class="rounded-xl elevation-16">
          <v-toolbar dense dark color="blueKonect" elevation="2">
            <v-toolbar-title>Detalle de usuario</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :disabled="loading" @click="update()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formDetail" lazy-validation v-on:submit.prevent>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="forms.detail.nombre"
                      :rules="[rules.required]"
                      prepend-icon="mdi-account"
                      label="Nombre"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      v-model="forms.detail.apellido_paterno"
                      :rules="[rules.required]"
                      prepend-icon="mdi-account"
                      label="Apellido paterno"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="forms.detail.apellido_materno"
                      :rules="[rules.required]"
                      prepend-icon="mdi-account"
                      label="Apellido Materno"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-dialog
                      ref="dialogBegin"
                      v-model="modalBegin"
                      :return-value.sync="forms.detail.fecha_nacimiento"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="forms.detail.fecha_nacimiento"
                          :rules="[rules.required]"
                          label="Fecha de nacimiento"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="forms.detail.fecha_nacimiento" scrollable locale="es">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modalBegin = false"> Cancelar </v-btn>
                        <v-btn text color="primary" @click="$refs.dialogBegin.save(forms.detail.fecha_nacimiento)">
                          Aceptar
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="forms.detail.numero_nomina"
                      :rules="[rules.required]"
                      prepend-icon="mdi-account"
                      label="Numero de nomina"
                      :disabled="loading"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogs.statusUser" persistent max-width="400">
        <v-card class="rounded-xl elevation-16" v-if="this.selected">
          <v-toolbar dense dark color="blueKonect" elevation="0">
            <v-toolbar-title>Aviso importante</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <p class="mt-5 text-h6" v-if="this.selected.estado == true">¿Está seguro de desactivar al usuario?</p>
            <p class="mt-5 text-h6" v-else>¿Está seguro de activar al usuario?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text :disabled="loading" color="blue-grey" @click="cancel()"> Cancelar </v-btn>
            <v-btn
              small
              text
              v-if="this.selected.estado == true"
              :loading="loading"
              color="error"
              @click="statusUser()"
            >
              Desactivar
            </v-btn>
            <v-btn small text v-else :loading="loading" color="success" @click="statusUser()"> Activar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogs.remove" persistent max-width="400">
        <v-card class="rounded-xl elevation-16" v-if="this.selected">
          <v-toolbar dense dark color="blueKonect" elevation="0">
            <v-toolbar-title>Aviso importante</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <p class="mt-5 text-h6" v-if="this.selected.acceso_usuarios == true">
              Desactivar el código al usuario ya no le permitirá verlo, ¿Está seguro de desactivar el código al usuario?
            </p>
            <p class="mt-5 text-h6" v-else>¿Está seguro de activar el código al usuario?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text :disabled="loading" color="blue-grey" @click="cancel()"> Cancelar </v-btn>
            <v-btn
              small
              text
              v-if="this.selected.acceso_usuarios == true"
              :loading="loading"
              color="error"
              @click="remove()"
            >
              Desactivar
            </v-btn>
            <v-btn small text v-else :loading="loading" color="success" @click="statusUser()"> Activar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogs.removeEmail" persistent max-width="400">
        <v-card class="rounded-xl elevation-16" v-if="this.selected">
          <v-toolbar dense dark color="blueKonect" elevation="0">
            <v-toolbar-title>Aviso importante</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <p class="mt-5 text-h6" v-if="this.selected.bloqueo_por_id == false">Deshabilitar reserva múltiple van</p>
            <p class="mt-5 text-h6" v-else>Habilitar reserva múltiple van</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text :disabled="loading" color="blue-grey" @click="cancel()"> Cancelar </v-btn>
            <v-btn
              small
              text
              v-if="this.selected.bloqueo_por_id == false"
              :loading="loading"
              color="error"
              @click="removeEmail()"
            >
              Desactivar
            </v-btn>
            <v-btn
              small
              text
              v-if="this.selected.bloqueo_por_id == true"
              :loading="loading"
              color="error"
              @click="removeEmail()"
            >
              Activar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogs.multipleEmail" persistent scrollable width="800" class="up">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title v-text="'Lista de emails bloqueados'" />
          </v-toolbar>
          <v-card-text class="py-6">
            <div style="display: flex">
              <v-autocomplete
                v-model="clientSearch"
                :items="clientItem"
                style="width: 300px"
                item-text="nombre_comercial"
                item-value="idcliente_externo"
                label="Clientes"
                hide-details
                prepend-icon="mdi-account-group"
                @change="getEmails()"
              ></v-autocomplete>
              <v-spacer></v-spacer>
              <v-text-field
                style="width: 300px"
                class="mr-2"
                v-model="email"
                label="Agregar email para bloquear"
                single-line
              ></v-text-field>
              <v-btn
                small
                center
                outlined
                :disabled="!email"
                :loading="loading"
                color="blueKonect"
                class="ma-auto"
                elevation="0"
                @click="blockEmail(false)"
              >
                Agregar
              </v-btn>
            </div>
            <p>Lista de emails bloqueados</p>
            <v-list-item style="border-bottom: 1px solid black" v-for="(email, index) in emails" :key="index">
              <v-list-item-content>
                <v-list-item-title v-text="email"></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="red" dark text v-bind="attrs" v-on="on">
                      <v-icon color="red lighten-1" @click="blockEmail(email)">mdi-trash-can</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar bloqueo</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              small
              center
              outlined
              color="red"
              :loading="loading"
              class="ma-auto ml-3"
              elevation="0"
              @click="cancel()"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right style="white-space: pre-line">
        {{ errorList[codeError] }}
        {{ '\n\n' + this.codeError }}
      </v-snackbar>
    </v-container>

    <!-- Modal para Cambiar Contraseña -->
    <v-dialog v-model="dialogs.changePassword" max-width="500px" persistent>
      <v-card>
        <v-toolbar dense dark color="blueKonect" elevation="2">
          <v-toolbar-title>Cambiar Contraseña de {{ selected?.nombre }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogs.changePassword = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form ref="changePasswordForm" lazy-validation>
            <v-text-field
              v-model="forms.password.newPassword"
              label="Nueva Contraseña"
              prepend-icon="mdi-lock"
              :rules="passwordRules"
              :type="showPasswords ? 'text' : 'password'"
              :append-icon="showPasswords ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPasswords = !showPasswords"
            ></v-text-field>
            <v-text-field
              v-model="forms.password.confirmPassword"
              label="Confirmar Contraseña"
              prepend-icon="mdi-lock-check"
              :rules="confirmPasswordRules"
              :type="showPasswords ? 'text' : 'password'"
              :append-icon="showPasswords ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPasswords = !showPasswords"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="submitChangePassword">Cambiar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import services from '@/utils/services'
import { tablek, errormsg, simpleDialog, infoBtn, csvButton, infoChip } from '@/components'
import moment_tz from 'moment-timezone'
import errorList from '@/utils/errorsList'
import { XlsxWorkbook, XlsxSheet, XlsxDownload } from 'vue-xlsx'

export default {
  name: 'Clientes',
  components: {
    tablek,
    errormsg,
    simpleDialog,
    csvButton,
    infoBtn,
    infoChip,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload
  },
  data: () => ({
    showPasswords: false,
    visible: false,
    loading: false,
    success: false,
    msgSuccess: '',
    clientItem: [],
    clientSearch: '',
    emails: [],
    email: '',
    users: [],
    codeError: '',
    code: '',
    state: '',
    stateValue: [
      {
        text: 'Activo',
        value: 1
      },
      {
        text: 'Todos',
        value: 2
      }
    ],
    idcliente: null,
    error: false,
    msgError: '',
    modalBegin: false,
    search: '',
    nameCSV:
      'Reporte de usuarios' +
      '-' +
      new Date().getDate() +
      '-' +
      new Date().getMonth() +
      '-' +
      new Date().getFullYear() +
      '.csv',
    headers: [
      {
        text: 'Empresa',
        align: 'center',
        sortable: true,
        value: 'nombre_comercial'
      },
      {
        text: 'Nombre',
        align: 'center',
        sortable: true,
        value: 'nombre'
      },
      {
        text: 'Apellido paterno',
        align: 'center',
        sortable: true,
        value: 'apellido_paterno'
      },
      {
        text: 'Apellido materno',
        align: 'center',
        sortable: true,
        value: 'apellido_materno'
      },
      {
        text: 'Teléfono',
        align: 'center',
        sortable: true,
        value: 'telefono'
      },
      {
        text: 'Email',
        align: 'center',
        sortable: true,
        value: 'email'
      },
      {
        text: 'Fecha de nacimiento',
        align: 'center',
        sortable: true,
        value: 'fech_nacimiento'
      },
      {
        text: 'Numero de nomina',
        align: 'center',
        sortable: true,
        value: 'numero_nomina'
      },
      {
        text: 'Fecha de inicio de acceso',
        align: 'center',
        sortable: true,
        value: 'cliente_codigo_usuario_fecha_creacion'
      },
      {
        text: 'Código usado',
        align: 'center',
        sortable: true,
        value: 'codigo'
      },
      {
        text: 'Ruta Mete',
        align: 'center',
        sortable: true,
        value: 'nombre_ruta_mete'
      },
      {
        text: 'Ruta Saca',
        align: 'center',
        sortable: true,
        value: 'nombre_ruta_saca'
      },
      {
        text: 'Estado',
        align: 'center',
        sortable: true,
        value: 'estado'
      },
      {
        text: 'Estado de codigo de usuario',
        align: 'center',
        sortable: true,
        value: 'cliente_codigo_usuario_fecha_borrado'
      },
      {
        text: 'Acciones',
        align: 'center',
        sortable: true,
        value: 'actions'
      }
    ],
    items: [],
    itemsAux: [],
    itemsCSV: [],
    forms: {
      detail: {
        idusuario_externo: null,
        nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        fecha_nacimiento: '',
        numero_nomina: ''
      },
      password: {
        newPassword: '',
        confirmPassword: ''
      }
    },
    dialogs: {
      remove: false,
      multipleEmail: false,
      removeEmail: false,
      statusUser: false,
      detail: false,
      changePassword: false
    },
    passwordRules: [
      (v) => !!v || 'La contraseña es requerida',
      (v) => v.length >= 8 || 'La contraseña debe tener al menos 8 caracteres',
      (v) => /[A-Z]/.test(v) || 'La contraseña debe tener al menos una letra mayúscula',
      (v) => /[a-z]/.test(v) || 'La contraseña debe tener al menos una letra minúscula',
      (v) => /\d/.test(v) || 'La contraseña debe tener al menos un número',
      (v) => /[!@#$%^&*(),.?":{}|<>]/.test(v) || 'La contraseña debe tener al menos un carácter especial',
      (v) => (v.length >= 8 && v.length <= 32) || 'La contraseña debe tener entre 8 y 32 caracteres'
    ],
    rules: {
      required: (v) => !!v || 'El campo es requerido',
      max13: (v) => (v || '').length <= 13 || 'Limite de caracteres',
      max200: (v) => (v || '').length <= 200 || 'Limite de caracteres',
      number: (v) => {
        if (!!v && v !== '') {
          return /^[0-9]+$/.test(v) || 'Número inválido'
        } else {
          return true
        }
      },
      email: (v) => {
        if (v !== '') {
          return /.+@.+\..+/.test(v) || 'Correo inválido'
        } else {
          return true
        }
      }
    },
    reportTypeGeneral: '',
    sheetsGeneral: [],
    selected: null,
    errorList
  }),
  mounted() {
    if (this.isReading) {
      this.state = 1
      this.refresh()
    }
  },
  computed: {
    confirmPasswordRules() {
      return [
        (v) => !!v || 'Confirmación de contraseña es requerida',
        (v) => v === this.forms.password.newPassword || 'Las contraseñas deben coincidir'
      ]
    },
    isReading: function () {
      return services.check(1, this.$route.path)
    },
    isWriting: function () {
      return services.check(2, this.$route.path)
    },
    isWritingVan: function () {
      return services.check(2, 'reservaMultiple')
    },
    canChangePasswords: function () {
      return services.check(2, 'changeUserPassword')
    }
  },
  methods: {
    openChangePassword(item) {
      this.selected = item
      console.log(item)
      this.dialogs.changePassword = true
    },
    submitChangePassword() {
      const isFormValid = this.$refs.changePasswordForm.validate()
      if (isFormValid) {
        const data = {
          idusuario_externo: this.selected.idusuario_externo,
          passwd: this.forms.password.newPassword
        }
        this.axios.put(services.routes.updatePassword, { data })
        this.dialogs.changePassword = false // Cerrar modal al finalizar
        this.success = true
        this.msgSuccess = `La contraseña de ${this.selected.nombre} fue cambiada exitosamente.`
        this.selected = null
      }
    },
    refresh() {
      this.loading = true
      this.items = []
      this.axios
        .get(services.routes.userIncedent)
        .then((res) => {
          this.items = res.data.data
          for (let i = 0; i < this.items.length; i++) {
            this.items[i].cliente_codigo_usuario_fecha_creacion = moment_tz
              .utc(this.items[i].cliente_codigo_usuario_fecha_creacion)
              .local()
              .format('YYYY-MM-DD HH:mm:ss')
            if (this.items[i].fech_nacimiento != null) {
              this.items[i].fech_nacimiento = moment_tz.utc(this.items[i].fech_nacimiento).format('YYYY-MM-DD')
            }
          }
          if (this.state == 1) {
            this.itemsAux = []
            for (let i = 0; i < this.items.length; i++) {
              if (this.items[i].estado == true) {
                this.itemsAux.push(this.items[i])
              }
            }
            this.items = this.itemsAux
          }

          this.reportTypeGeneral = 'Usuarios'
          this.sheetsGeneral = [
            {
              name: 'Reporte de viaje',
              data: [{}]
            }
          ]
          if (this.items.length > 0) {
            this.sheetsGeneral[0].data.shift()
          }
          for (let i = 0; i < this.items.length; i++) {
            let obj = {
              Empresa: this.items[i].nombre_comercial ? this.items[i].nombre_comercial : '',
              Nombre: this.items[i].nombre ? this.items[i].nombre : '',
              'Apellido Paterno': this.items[i].apellido_paterno ? this.items[i].apellido_paterno : '',
              'Apellido Materno': this.items[i].apellido_materno ? this.items[i].apellido_materno : '',
              Teléfono: this.items[i].telefono ? this.items[i].telefono : '',
              Email: this.items[i].email ? this.items[i].email : '',
              'Fecha de nacimiento': this.items[i].fech_nacimiento ? this.items[i].fech_nacimiento : '',
              'Numero de nomina': this.items[i].numero_nomina ? this.items[i].numero_nomina : '',
              'Fecha de inicio de acceso': this.items[i].cliente_codigo_usuario_fecha_creacion
                ? this.items[i].cliente_codigo_usuario_fecha_creacion
                : '',
              'Código usado': this.items[i].codigo ? this.items[i].codigo : '',
              'Ruta Mete': this.items[i].nombre_ruta_mete ? this.items[i].nombre_ruta_mete : '',
              'Ruta Saca': this.items[i].nombre_ruta_saca ? this.items[i].nombre_ruta_saca : '',
              Estado: this.items[i].estado == true ? 'Activo' : 'Inactivo',
              'Estado de código usuario':
                this.items[i].cliente_codigo_usuario_fecha_borrado == null ? 'Activo' : 'Inactivo'
            }
            this.sheetsGeneral[0].data.push(obj)
          }
          if (this.items.length == 0) {
            this.success = true
            this.msgSuccess = 'No existen reportes de clientes'
          } else {
            this.success = true
            this.msgSuccess = 'Reportes obtenidos correctamente'
          }
        })
        .catch((error) => {
          this.error = true
          this.codeError = error.response.data.code
        })
        .finally(() => {
          this.loading = false
        })
    },
    dataCSV() {
      if (this.state) {
        this.itemsCSV = this.items
        for (let i = 0; i < this.itemsCSV.length; i++) {
          if (this.itemsCSV[i].estado == true) {
            this.itemsCSV[i].estado = 'Activo'
          } else {
            this.itemsCSV[i].estado = 'Inactivo'
          }
        }
        this.success = true
        this.msgSuccess = 'Descargando documento'
      } else {
        this.itemsCSV = []
        this.error = true
        this.codeError = 'NO_FILTTER'
      }
    },
    remove(item) {
      if (!this.dialogs.remove) {
        this.itemDelete = item
        this.selected = JSON.parse(JSON.stringify(item))
        this.dialogs.remove = true
      } else {
        this.item = null
        this.loading = true
        let data = {
          data: {
            idusuario_externo: this.selected.idusuario_externo
          }
        }
        services
          .ws('delete', 'deleteCode', data)
          .then((res) => {
            this.cancel()
            this.refresh()
            this.success = true
            this.msgSuccess = 'Cliente eliminada correctamente'
          })
          .catch((error) => {
            this.error = true
            this.codeError = error.response.data.code
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    removeEmail(item) {
      if (!this.dialogs.removeEmail) {
        this.itemDelete = item
        this.selected = JSON.parse(JSON.stringify(item))
        this.dialogs.removeEmail = true
      } else {
        this.item = null
        this.loading = true
        let data = {
          data: {
            idusuario_externo: this.selected.idusuario_externo,
            idcliente_externo: this.selected.idcliente_externo,
            action: this.selected.bloqueo_por_id ? 'enabled' : 'disabled'
          }
        }
        services
          .ws('post', 'updateStatusMultiple', data)
          .then((res) => {
            this.cancel()
            this.refresh()
            this.success = true
            this.msgSuccess = 'Usuario actualizado correctamente'
          })
          .catch((error) => {
            this.error = true
            this.codeError = error.response.data.code
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    getClients() {
      this.loading = true
      services
        .ws('get', 'clients')
        .then((res) => {
          this.itemsAux = res.data
          this.clientItem = res.data
          if (this.clientItem) {
            this.clientSearch = this.clientItem[0].idcliente_externo
          }
          this.getEmails()
        })
        .catch((error) => {
          this.error = true
          this.codeError = error.response.data.code
        })
        .finally(() => {
          this.loading = false
        })
    },
    getEmails() {
      this.item = null
      this.loading = true
      this.email = []
      let data = {
        data: {
          idcliente_externo: this.clientSearch
        }
      }
      services
        .ws('post', 'getEmails', data)
        .then((res) => {
          this.emails = res.data
          this.success = true
          this.msgSuccess = 'Emails obtenidos correctamente'
        })
        .catch((error) => {
          this.error = true
          this.codeError = error.response.data.code
        })
        .finally(() => {
          this.loading = false
        })
    },
    openMultipleMail() {
      this.dialogs.multipleEmail = true
      this.getClients()
    },
    blockEmail(block) {
      this.emails = []
      this.loading = true
      let data = {
        data: {
          email: block ? block : this.email,
          idcliente_externo: this.clientSearch,
          action: block ? 'enabled' : 'disabled'
        }
      }
      services
        .ws('post', 'updateStatusMultiple', data)
        .then((res) => {
          this.getEmails()
          this.email = ''
          this.loading = false
          this.success = true
          this.msgSuccess = 'Email actualizado correctamente'
        })
        .catch((error) => {
          this.error = true
          this.loading = false
          this.codeError = error.response.data.code
        })
        .finally(() => {
          this.loading = false
        })
    },
    statusUser(item) {
      if (!this.dialogs.statusUser) {
        this.selected = JSON.parse(JSON.stringify(item))
        this.dialogs.statusUser = true
      } else {
        this.loading = true
        let data = {
          data: {
            idusuario_externo: this.selected.idusuario_externo,
            estado: !this.selected.estado
          }
        }
        services
          .ws('post', 'clientUser', data)
          .then((res) => {
            if (res.ok) {
              this.cancel()
              this.refresh()
              this.success = true
              this.msgSuccess = 'Estatus de usuario actualizado correctamente'
            }
          })
          .catch((error) => {
            this.error = true
            this.codeError = error.response.data.code
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    view(item) {
      this.selected = JSON.parse(JSON.stringify(item))
      this.forms.detail.idusuario_externo = this.selected.idusuario_externo
      this.forms.detail.nombre = this.selected.nombre
      this.forms.detail.apellido_paterno = this.selected.apellido_paterno
      this.forms.detail.apellido_materno = this.selected.apellido_materno
      this.forms.detail.fecha_nacimiento = this.selected.fech_nacimiento != null ? this.selected.fech_nacimiento : ''
      this.forms.detail.numero_nomina = this.selected.numero_nomina
      this.dialogs.detail = true
    },
    update() {
      if (this.$refs.formDetail.validate()) {
        this.loading = true
        let data = {
          idusuario_externo: this.forms.detail.idusuario_externo,
          nombre: this.forms.detail.nombre,
          apellido_paterno: this.forms.detail.apellido_paterno,
          apellido_materno: this.forms.detail.apellido_materno,
          fecha_nacimiento: this.forms.detail.fecha_nacimiento,
          numero_nomina: this.forms.detail.numero_nomina
        }
        services
          .ws('put', 'updateClient', { data: data })
          .then((res) => {
            if (res.ok) {
              this.refresh()
              this.cancel()
              this.success = true
              this.msgSuccess = 'Usuario actualizado correctamente'
            }
          })
          .catch((error) => {
            this.error = true
            this.message = error.response.data.code
          })
          .finally(() => {})
      }
    },
    cancel() {
      this.dialogs.multipleEmail = false
      this.dialogs.removeEmail = false
      this.dialogs.remove = false
      this.dialogs.statusUser = false
      this.dialogs.detail = false
    },
    closeMsg() {
      this.error = false
    }
  }
}
</script>

<style scoped></style>
